import Vue from 'vue';
import Vuetify from 'vuetify/lib/framework';
import id from 'vuetify/src/locale/id';

Vue.use(Vuetify, {
    components: {

    }
});

export default new Vuetify({
    lang: {
        locales: { id },
        current: 'id'
    },
    icons: {
        iconfont: 'mdi'
    }
});
